import { translate } from 'loankeeper-common/helpers'

export default (key: string): string => translate(`frm_creports-${key}`)
export const translateLKMessage = (key: string): string => translate(`LKMESSAGE-${key}`)
export const translateFrm = (key: string): string => translate(`frm_web_messages-${key}`)
export const TranslateExcel = (key: string): string => translate(`frm_Main-${key}`)
